import React from 'react';
import RepVisitsUnlockPremiumView from '../RepVisitsUnlockPremiumView';
import overviewUnlockMessages from './overview-unlock-messages';
import PageTitle from '../../components/PageTitle';

const unlockPremiumProps = {
  activeStyle: 'overview',
  messages: overviewUnlockMessages,
};

const RepVisitsRecommendationsUnlockPage = () => (
  <div>
    <PageTitle title="RepVisits" category="Intersect" />
    <RepVisitsUnlockPremiumView {...unlockPremiumProps} />
  </div>
);

export default RepVisitsRecommendationsUnlockPage;
